import { render, staticRenderFns } from "./c_is_show.vue?vue&type=template&id=3ff7834f&scoped=true&"
import script from "./c_is_show.vue?vue&type=script&lang=js&"
export * from "./c_is_show.vue?vue&type=script&lang=js&"
import style0 from "./c_is_show.vue?vue&type=style&index=0&id=3ff7834f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff7834f",
  null
  
)

export default component.exports